export default "__VITE_ASSET__G$_YIUxI__"